import React from 'react';
import './index.scss';
import deliveryImage from '../../../assets/images/service-type/delevery_image2.png';
import dineInImage from '../../../assets/images/service-type/dine_image2.png';
import logoImage from '../../../assets/images/logo.png';
import { THEME } from '../../constants/app-constants';
import closeIcon from '../../../assets/images/close-orange-symbol.svg'
import { updateServiceTypeFromThemeHandler } from '../../burger-king-lib/redux/home/actions';
import { useDispatch } from 'react-redux';

const imageslink = {
  logo: logoImage,
  dineIn: dineInImage,
  delivery: deliveryImage
};

function SelectService({ onClose, onOrderTypeChange }) {
  const dispatch = useDispatch()
  const handleClose = () => {
    dispatch(updateServiceTypeFromThemeHandler(false))
  };

  const handleOrderTypeChange = value => {
    if (!value) return;
    if (!!onOrderTypeChange && typeof onOrderTypeChange === 'function')
      onOrderTypeChange(value);
  };

  return (
    <div className="select-service">
      <div className="select-service__modal-container">
        <div  className='select-service__close-icon-container' onClick={handleClose}>
          <img className='select-service__close-icon' src={closeIcon} alt="closeIcon" />
        </div>
        <div className="select-service__responsive-container">
          <div className="select-service___logo-container">
            <img
              src={imageslink.logo}
              alt="logo"
              className="select-service__logo"
            />
          </div>
          <h1 className="select-service__heading">Select Service</h1>
          <div className="select-service__mode-containers">
            <div
              className="select-service__card_container"
              onClick={() => handleOrderTypeChange(THEME.DELIVERY)}
            >
              <img
                src={imageslink.delivery}
                alt="delivery"
                className="select-service__card_container-image"
              />
              <p>Delivery</p>
            </div>
            <div
              className="select-service__card_container"
              onClick={() => handleOrderTypeChange(THEME.RESTAURANT)}
            >
              <img
                src={imageslink.dineIn}
                alt="Dine in"
                className="select-service__card_container-image"
              />
              <p>Dine in / Takeaway</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SelectService;
